import React, { type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import Checkbox from 'atom-components/form-fields-for-hook-form/checkbox';
import { type BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';
import { orgUsersWhoCanReviewEscalatedMarks } from './active-reviewer.helpers';
import styles from './active-reviewer.module.scss';

const fieldLabel = 'Escalate for further review';
const fieldName = 'furtherEscalated';

function userCanReviewEscalatedMarks(
  organisationUserId: number | null,
  organisationUsers: BaseCustomerUser[]
): boolean {
  return organisationUsers.some((orgUser) => orgUser.id === organisationUserId);
}

export default function ReviewStatusSwitch({ organisationUsers }): ReactElement {
  const { control, setValue, trigger, watch, formState } = useFormContext();

  const organisationUserId = watch('organisationUserId');
  const filteredOrganisationUsers = orgUsersWhoCanReviewEscalatedMarks(organisationUsers);

  return (
    <div className={styles.reviewStatusSwitchContainer}>
      <Checkbox role="switch">
        <Checkbox.Input
          id={fieldName}
          control={control}
          name={fieldName}
          role="switch"
          onChange={(event): void => {
            // Clear the current reviewer when further escalated is toggled and the reviewer is not in the filtered orgUsersWhoCanReviewEscalatedMarks list.
            if (
              event.target.checked &&
              !userCanReviewEscalatedMarks(organisationUserId, filteredOrganisationUsers)
            ) {
              setValue('organisationUserId', null);
            } else {
              setValue('organisationUserId', formState.defaultValues?.organisationUserId);
            }
            setValue(fieldName, event.target.checked);
            trigger();
          }}
        />
        <Checkbox.Label htmlFor={fieldName}>{fieldLabel}</Checkbox.Label>
      </Checkbox>
    </div>
  );
}
